import React from 'react';

export const Arrow = () => (
  <svg width="40px" height="40px" viewBox="0 0 40 40">
    <g id="App" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle-Copy-3" fill="#FFFFFF" x="0" y="0" width="40" height="40" rx="20" />
      <polygon
        id="Path"
        fill="#222222"
        fillRule="nonzero"
        points="22 12.9296875 20.5 14.4296875 25.070312 19 11 19 11 21 25.070312 21 20.5 25.570312 22 27.070312 29.070312 20"
      />
    </g>
  </svg>
);
